/* unplugin-vue-components disabled */import { render } from "./VabMenuItem.vue?vue&type=template&id=5c6e3810&scoped=true"
import script from "./VabMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VabMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./VabMenuItem.vue?vue&type=style&index=0&id=5c6e3810&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./VabMenuItem.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6e3810"],['__file',"library/components/VabMenu/components/VabMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c6e3810"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c6e3810', __exports__)) {
    api.reload('5c6e3810', __exports__)
  }
  
  module.hot.accept("./VabMenuItem.vue?vue&type=template&id=5c6e3810&scoped=true", () => {
    api.rerender('5c6e3810', render)
  })

}


export default __exports__